<template>
  <v-app>
      <div class="animated fadeIn">

         <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

         <v-switch
            dense
            v-model="listMode"
            @change="change_listMode"
            :label="$t('texts.list_mode')"
         >
         </v-switch>

         <ddoClientList key="StartingList1" v-if="!listMode" :loading="loading" :level="levels[0]" 
            :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
            @loading="refresh_loading"
            @childKey="refresh_childKey"
            @row="refresh_row"
            @errors="refresh_errors"
         >

            <template v-slot:superheader="slotProps">
               <h2>{{ $t('titles.crg') }}</h2>
            </template>

            <template v-slot:dialogform="{ row, level }">
               <CardUpdatableCertificateRegistar :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
                  @errors="refresh_errors"
               />
            </template>

            <template v-slot:child_row="{ props }">
               <ddoClientList :loading="loading" :level="levels[1]" :childKey="levels[1].childKey"
                  :columns="levels[1].columns" :options="levels[1].options" :callbacks="levels[1].callbacks"
                  @childKey="refresh_childKey"
                  @row="refresh_row"
               >

                  <template v-slot:superheader="slotProps">
                  <h3>{{ $api._format($t('subtitles.cer'),slotProps.parentToggledRow['crg_code']) }}</h3>
                  </template>

                  <template slot="cer_active" slot-scope="props">
                     <b-checkbox disabled v-model="props.row.cer_active"></b-checkbox>
                  </template>

                  <template v-slot:dialogform="{ row, level }">
                     <CardUpdatableCertificate ref="myCardCertificate" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"/>
                  </template>

                  <template v-slot:child_row="{ props }">
                     <ddoClientList :loading="loading" :level="levels[2]" :childKey="levels[2].childKey"
                        :columns="levels[2].columns" :options="levels[2].options" :callbacks="levels[2].callbacks"
                        @childKey="refresh_childKey"
                        @row="refresh_row"
                     >

                        <template slot="ced_active" slot-scope="props">
                           <b-checkbox disabled v-model="props.row.ced_active"></b-checkbox>
                        </template>

                        <template v-slot:superheader="slotProps">
                           <h4>{{ $api._format($t('subtitles.ced'),slotProps.parentToggledRow['cer_cn']) }}</h4>
                        </template>
                        <template v-slot:dialogform="{ row, level }">
                           <CardUpdatableCertificatedeployment key="UpdateCED1" ref="myCardCertificateDeployment" :row="levels[2].row" :depth="levels[2].level" :level="levels[2]"/>
                        </template>

                     </ddoClientList>
                  </template>

               </ddoClientList>
            </template>

         </ddoClientList>

         <ddoClientList name="StartingList2" key="StartingList2" v-if="listMode" :loading="loading" :level="levels[3]"
            :columns="levels[3].columns" :options="levels[3].options" :callbacks="levels[3].callbacks"
            :customSlotNames="levels[3].customSlotNames"
            @childKey="refresh_childKey"
            @row="refresh_row"
            ref="myCEDList2"
            >

            <template v-slot:superheader="slotProps">
               <h3>{{ $t('titles.ced') }}</h3>
            </template>

            <template slot="cer_active" slot-scope="props">
               <b-checkbox disabled v-model="props.row.cer_active"></b-checkbox>
            </template>

            <template slot="ced_active" slot-scope="props">
               <b-checkbox disabled v-model="props.row.ced_active"></b-checkbox>
            </template>

            <template v-slot:header="slotProps">
               <v-row>
                  <v-col sm="6">
                     <v-btn @click="$refs.myCEDList2.load_for_create('new_deployment')" class="primary" rounded :disabled="buttonAttachCER">
                        <v-icon large>mdi-plus</v-icon>
                        Déclarer un Nouveau Déploiement de Certificat :
                     </v-btn>
                  </v-col>
                  <v-col sm="6">
                     <ddoSelect2
                        :callbacks="CERcallbacks"
                        ref="mySelectCER"
                        :options="CERoptions"
                     >
                        <template v-slot:selection="data">
                           <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                           >
                              <span>{{data.item.cer_cn}}</span>
                           </v-chip>
                        </template>

                        <template v-slot:item="data">
                           <v-list-item-content>
                              <v-list-item-title>{{data.item.cer_cn}} ({{data.item.crg_name}})</v-list-item-title>
                           </v-list-item-content>
                        </template>
                     </ddoSelect2>
                  </v-col>
               </v-row>
               <v-row>
                  <v-col sm="6">
                     <v-btn @click="$refs.myCEDList2.load_for_create('new_certificateanddeployment')" class="primary" rounded :disabled="buttonAttachCRG">
                        <v-icon large>mdi-plus</v-icon>
                        Déclarer un Nouveau Certificat avec son Déploiement :
                     </v-btn>
                  </v-col>
                  <v-col sm="6">
                     <ddoSelect2
                        :callbacks="CRGcallbacks"
                        ref="mySelectCRG"
                        :options="CRGoptions"
                     >
                        <template v-slot:selection="data">
                           <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                           >
                              <span>{{data.item.crg_name}}</span>
                           </v-chip>
                        </template>

                        <template v-slot:item="data">
                           <v-list-item-content>
                              <v-list-item-title>{{data.item.crg_name}} ({{data.item.crg_code}})</v-list-item-title>
                           </v-list-item-content>
                        </template>
                     </ddoSelect2>
                  </v-col>
               </v-row>
            </template>

            <template v-slot:dialogform="{ row, level }">
               <CardUpdatableCertificatedeployment key="UpdateCED2" :row="levels[3].row" ref="myCardCertificateDeployment2" :depth="levels[3].level" :level="levels[3]"/>
            </template>

         </ddoClientList>

      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import ddoClientList from '@/components/ddoClientList.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';

import CardUpdatableCertificateRegistar from '@/components/partials/CardUpdatableCertificateRegistar.vue';
import CardUpdatableCertificate from '@/components/partials/CardUpdatableCertificate.vue';
import CardUpdatableCertificatedeployment from '@/components/partials/CardUpdatableCertificatedeployment.vue';

let initial_row = {}

export default {
   name: 'certificate',
   components: {
      ddoAlert,
      ddoWaiting,
      ddoClientList,
      CardUpdatableCertificateRegistar,
      CardUpdatableCertificate,
      CardUpdatableCertificatedeployment,
      ddoSelect2,

   },
   data: () => {
      return {
         _this: null,
         loading: false,
         listMode: true,

         buttonAttachCER: true,
         selectedCER: {},
         CERcallbacks: {},
         CERoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "cer_cn",
            item_value: "cer_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.list_certificates'),
         },

         buttonAttachCRG: true,
         selectedCRG: {},
         CRGcallbacks: {},
         CRGoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "crg_name",
            item_value: "crg_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.list_registars'),
         },

         /* 
         * LEVEL 1 : all for ddoClientList : columns, options, callbacks
         */
         levels: [

         {
            api_code: 'certificateregistar',
            api_prefix: 'crg',
            row: {},
            level: 0,
            errors: [],
            columns: [ '_actions', 'crg_code', 'crg_desc', '_update'],
            options: {
               showChildRowToggler: false,
               withChild: true,
               hiddenColumns: [],
               headings: {
                  _pk: i18n.t('headers.actions'),
                  _child: i18n.t('headers.cer'),
                  crg_pk: '#',
                  crg_code: i18n.t('headers.code'),
                  crg_desc: i18n.t('headers.description'),
                  _update: i18n.t('headers.updated_on')
               },
               texts: {
               },
               uniqueKey: 'crg_pk',
               sortable: ['crg_code','_update'],
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               columnsDropdown: false,
               pagination: {
                  chunk: 5,
                  edge: false,
                  nav: 'scroll'
               },
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.crg_create_title'),
                  update: i18n.t('texts.crg_update_title'),
                  delete: i18n.t('texts.crg_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               header_value_function: function(row) { return row['crg_code']; }
            },
         },

         {
            /* 
               * LEVEL 2 : all for ddoClientList : columns_l2, options_l2, callbacks_l2
            */
            api_code: 'certificate',
            api_prefix: 'cer',
            row: {},
            level: 1,
            errors: [],
            columns: [ '_actions', 'cer_cn', 'cer_active', '_update' ],
            customSlotNames: ['cer_active'],
            options: {
               showChildRowToggler: false,
               withChild: true,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  cer_pk: '#',
                  cer_cn: i18n.t('headers.cer_cn'),
                  cer_active: i18n.t('texts.cer_active'),
                  cer_desc: i18n.t('headers.description'),
                  _update: i18n.t('headers.updated_on')
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'cer_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.cer_create_title'),
                  update: i18n.t('texts.cer_update_title'),
                  delete: i18n.t('texts.cer_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               parentKeyName: 'crg_pk',
               header_value_function: function(row) { return row['cer_cn']; }
            },
         },

         {
            /* 
             * LEVEL 3 : all for ddoClientList : columns_l3, options_l3, callbacks_l3
             */
            api_code: 'certificatedeployment',
            api_prefix: 'ced',
            row: {},
            level: 2,
            errors: [],
            columns: [ '_actions', 'ced_code', 'ced_check_uri', 'ced_active', '_update' ],
            customSlotNames: ['ced_active'],
            options: {
               showChildRowToggler: false,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  ced_pk: '#',
                  ced_code: 'Code',
                  ced_active: i18n.t('texts.ced_active'),
                  ced_check_uri: i18n.t('texts.ced_check_uri'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'ced_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.ced_create_title'),
                  update: i18n.t('texts.ced_update_title'),
                  delete: i18n.t('texts.ced_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               parentKeyName: 'cer_pk',
               header_value_function: function(row) { return row['cer_cn']; },
               with_CERT: false,
            },
         },

         {
            /* 
             * LEVEL 4 : all for ddoClientList : columns_l4, options_l4, callbacks_l4
             */
            api_code: 'certificatedeployment',
            api_prefix: 'ced',
            row: {},
            level: 3,
            errors: [],
            columns: [ '_actions', 'cer_cn', 'cer_active', 'ced_code', 'ced_check_uri', 'ced_active', '_update' ],
            customSlotNames: ['cer_active', 'ced_active'],
            options: {
               showChildRowToggler: false,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  ced_pk: '#',
                  cer_cn: i18n.t('headers.cer_cn'),
                  ced_code: 'Code',
                  cer_active: i18n.t('texts.cer_active'),
                  ced_active: i18n.t('texts.ced_active'),
                  ced_check_uri: i18n.t('texts.ced_check_uri'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'ced_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  create: i18n.t('texts.ced_create_title'),
                  update: i18n.t('texts.ced_update_title'),
                  delete: i18n.t('texts.ced_delete_title'),
               },
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               parentKeyName: 'cer_pk',
               header_value_function: function(row) { return row['cer_cn']; },
               with_CERT: false,
            },
         }

         ],

         model: {},
         dialogShow: false,
         dialogId: null,
         dialogcode: null,

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;
      this.levels[0].callbacks.configure_form = this.configure_form;
      this.levels[0].callbacks.show_dialog    = this.show_dialog;
      this.levels[0].callbacks.prepare_create = this.prepare_create;
      this.levels[0].callbacks.prepare_update = this.prepare_update;
      this.levels[0].callbacks.prepare_delete = this.prepare_delete;
      this.levels[0].callbacks.refresh_errors = this.refresh_errors;

      this.levels[1].callbacks.refresh_rows   = this.refresh_rows_l2;
      this.levels[1].callbacks.prepare_create = this.prepare_create_l2;    
      this.levels[1].callbacks.prepare_update = this.prepare_update_l2;
      this.levels[1].callbacks.prepare_delete = this.prepare_delete_l2;
      this.levels[1].callbacks.configure_form = this.configure_form;
      this.levels[1].callbacks.show_dialog    = this.show_dialog;
      this.levels[1].callbacks.refresh_errors = this.refresh_errors;

      this.levels[2].callbacks.refresh_rows   = this.refresh_rows_l3;
      this.levels[2].callbacks.prepare_create = this.prepare_create_l3;    
      this.levels[2].callbacks.prepare_update = this.prepare_update_l3;
      this.levels[2].callbacks.prepare_delete = this.prepare_delete_l3;
      this.levels[2].callbacks.configure_form = this.configure_form;
      this.levels[2].callbacks.show_dialog    = this.show_dialog;
      this.levels[2].callbacks.refresh_errors = this.refresh_errors;
      this.levels[2].callbacks.after_create_row = this.after_create_row;
      this.levels[2].callbacks.after_delete_row = this.after_delete_row;
      
      this.levels[3].callbacks.refresh_rows     = this.refresh_rows_l4;
      this.levels[3].callbacks.prepare_create   = this.prepare_create_l4;
      this.levels[3].callbacks.prepare_update   = this.prepare_update_l4;
      this.levels[3].callbacks.create_row       = this.create_row_l4;
      this.levels[3].callbacks.configure_form   = this.configure_form;
      this.levels[3].callbacks.show_dialog      = this.show_dialog;
      this.levels[3].callbacks.refresh_errors   = this.refresh_errors;
      this.levels[3].callbacks.after_create_row = this.after_create_row;
      this.levels[3].callbacks.after_delete_row = this.after_delete_row;

      this.CERcallbacks.refresh_rows = this.build_select_cer;
      this.CERcallbacks.change       = this.change_cer;

      this.CRGcallbacks.refresh_rows = this.build_select_crg;
      this.CRGcallbacks.change       = this.change_crg;
   },

   mounted() {
   },

   methods: {

      async change_listMode(value) {
         if ( value===true ) {
            this.levels[3].errors = [];
            this.levels[3].rows = [];
         } else {
            this.levels[0].errors = [];
            this.levels[0].rows = [];
         }
      },

      refresh_loading(value) {
         this.loading = value;
      },

      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },

      async refresh_rows_l2(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+key+'/certificates');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async refresh_rows_l3(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[1].api_code+'/'+key+'/deployments');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async refresh_rows_l4(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[3].api_code);
         this.loading = false;
         return { errorinfos, api_response }
      },

      refresh_row(level,row) {
         this.levels[level].row = row;
      },

      async prepare_create(parentKey=null) {
         this.levels[0].errors = [];
         this.levels[0].row.array_patterns = [];
      },

      async prepare_update(parentKey=null) {
         this.levels[0].errors = [];
      },

      async prepare_delete(parentKey=null) {
         this.levels[0].errors = [];
      },

      prepare_create_l2(parentKey=null,origin=null) {
         this.levels[1].errors = [];
         this.levels[1].dialogValues.with_CERT = false;
         if ( origin==null ) {
            this.$refs.myCardCertificate.CRGoptions.selected  = this.levels[1].toggledRow._pk;
            this.levels[1].row.crg_pk   = this.levels[1].toggledRow._pk;
         }
      },

      prepare_update_l2(parentKey=null,_pk,row=null,origin=null) {
         //console.log('prepare_update_l2, row='+JSON.stringify(row));
         this.$refs.myCardCertificate.CRGoptions.selected  = this.levels[1].row.crg_pk;
         this.$refs.myCardCertificate.CUSoptions.selected  = this.levels[1].row.cus_pk;
      },

      prepare_delete_l2(parentKey=null,_pk,row=null,origin=null) {
         this.$refs.myCardCertificate.CRGoptions.selected  = this.levels[1].row.crg_pk;
         this.$refs.myCardCertificate.CUSoptions.selected  = this.levels[1].row.cus_pk;
      },

      prepare_create_l3(parentKey=null,origin=null) {
         this.levels[2].errors = [];
         this.levels[2].row.cer_pk     = this.levels[2].toggledRow._pk;
         this.levels[2].row.cer_cn     = this.levels[2].toggledRow.cer_cn;
         this.levels[2].row.ced_code   = this.levels[2].toggledRow.cer_cn + '-' + (this.levels[2].toggledRow._count+1);
         this.levels[2].row.ced_active = true;
         this.levels[2].dialogValues.with_CERT = false;
         //console.log('prepare_create_l3, row='+JSON.stringify(this.levels[2].toggledRow))
      },

      prepare_delete_l3(parentKey=null,_pk,row=null,origin=null) {
         this.levels[2].errors = [];
      },

      async prepare_create_l4(parentKey=null,origin=null) {
         //console.log('prepare_create_l4, parentKey='+parentKey+', origin='+origin);
         this.levels[3].errors = [];
         if ( origin=='new_deployment' ) {   
            //console.log('prepare_create_l4, parentKey='+parentKey+', selectedCER='+JSON.stringify(this.selectedCER));
            if ( this.selectedCER._pk ) {
               this.levels[3].row.cer_pk   = this.selectedCER._pk;
               this.levels[3].row.cer_cn   = this.selectedCER.cer_cn;
               this.levels[3].row.ced_code = this.selectedCER.cer_cn + '-' + (this.selectedCER._count+1);
            }
         }
         if ( origin=='new_certificateanddeployment' ) {
            //console.log('prepare_create_l4, parentKey='+parentKey+', selectedCRG='+JSON.stringify(this.selectedCRG));
            if ( this.selectedCRG._pk ) {
               this.levels[3].row.crg_pk     = this.selectedCRG._pk;
               this.levels[3].row.crg_name   = this.selectedCRG.crg_name;
               this.levels[3].row.cer_active = true;
               this.levels[3].row.ced_active = true;
               this.$refs.myCardCertificateDeployment2.CRGoptions.selected  = this.levels[3].row.crg_pk;
            }
            this.levels[3].dialogValues.with_CERT = true;
         } else {
            this.levels[3].dialogValues.with_CERT = false;
         }
      },

      async create_row_l4(router,api_code,row) {      
         if ( this.levels[3].dialogValues.with_CERT==true ) {
            api_code = api_code+'/certificateanddeployment';
         }
         var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row);
         return { errorinfos, api_response }
      },

      async build_select_crg(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'certificateregistar');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_crg(value,item=null) {
         this.levels[3].row.crg_pk = value;
         if ( item!=null ) {
            this.selectedCRG = item;
         } else {
            this.selectedCRG = this.$api._get_by_pk(this.$refs.mySelectCRG.items,value);
         }
         this.buttonAttachCRG = ( value==null ? true : false);
      },

      async build_select_cer(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'certificate');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_cer(value,item=null) {
         this.levels[3].row.cer_pk = value;
         if ( item!=null ) {
            this.selectedCER = item;
         } else {
            this.selectedCER = this.$api._get_by_pk(this.$refs.mySelectCER.items,value);
         }
         this.buttonAttachCER = ( value==null ? true : false);
      },

      after_create_row(level,errorinfos,api_response) {
         if ( api_response.error==0 && this.levels[level].toggledRow && this.levels[level].toggledRow._count ) {
            this.levels[level].toggledRow._count++;
         }
      },

      after_delete_row(level,errorinfos,api_response) {
         if ( api_response.error==0 && this.levels[level].toggledRow && this.levels[level].toggledRow._count ) {
            this.levels[level].toggledRow._count--;
         }
      },

      refresh_childKey(level,key,toggledRow=null) {
         this.levels[level].childKey = key;
         this.levels[level].toggledRow = toggledRow;
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow   = show;
         this.levels[level].dialogValues = _dV;
      },

   }
}
</script>